import { render, staticRenderFns } from "./EmailRecipientsManual.vue?vue&type=template&id=6d8363d1&scoped=true&"
import script from "./EmailRecipientsManual.vue?vue&type=script&lang=js&"
export * from "./EmailRecipientsManual.vue?vue&type=script&lang=js&"
import style0 from "./EmailRecipientsManual.vue?vue&type=style&index=0&id=6d8363d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8363d1",
  null
  
)

export default component.exports